import { Injectable } from '@angular/core';
import { apisDataCacheKeys, ApiUrlConstant } from 'projects/selflearnv2-ui/src/app/constants/app.constants';
import { RestApiService } from '../rest/rest-api.service';
import { forkJoin, Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SelfLearnService extends RestApiService {
  apiUrl = ApiUrlConstant.SELF_LEARN_API + '/api';
  apiUrlV2 = ApiUrlConstant.SELF_LEARN_API_V2 + 'api';
  apiQb = ApiUrlConstant.qbAPi;
  cmsURl = ApiUrlConstant.cmsapi;
  omsurl = ApiUrlConstant.omsdevapi;
  uafApi = ApiUrlConstant.uafapi;
  myActivityApi = ApiUrlConstant.myActivity;
  apiLsqUrl = ApiUrlConstant.apiUrl;

  examUrl =  ApiUrlConstant.examUrl;
  // apiUrl = 'http://3.109.201.1/selflearnservice/api';
  playListVideo: any;
  selfLearnHomepagePlaylsit: any = {
    trendingVideosPlaylist: [],
    recommendedVideosPlayList: [],
    shortsVideosPlayList: [],
    puzzleVideosPlayList: [],
    listEnabled: false
  }

  isFromLearn(){
    const tenantId = JSON.parse(localStorage.getItem('userInfo'))?.userDto.tenantId.toString()
    return (tenantId == 1) ? true : false;
  }

  getUAMExamIdForLearn() {
    const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
    const examId = details.find((e:any) => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId;
    const selfLearnSelectedExamId =  localStorage.getItem('selfLearUamExamId');
    return selfLearnSelectedExamId ? selfLearnSelectedExamId :examId;
  }

  getGradeId() {
    const userData = JSON.parse(localStorage.getItem('cmsInfo'));
    return userData.cmsGradeId;
  }

  getUserInfo() {
    const userData = JSON.parse(localStorage.getItem('userInfo'))?.userDto
    return {
      phone_number: Number(userData.phone),
      email: userData?.email || "",
      userId: userData?.userId?.toString(),
      name: userData?.firstName + " " + userData.lastName,
      type: "free",
    }
  }

  getUserAcademics() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return {
      class: userData?.grade?.name,
      stream: userData?.stream?.name,
      target_exams: JSON.stringify(userData?.exams?.map((exam: any) => {
        let obj: any = {};
        obj[exam.name] = {
          exam_id: exam.examId,
          target_year: 0,
          exam_progress: 0,
          focused_exam: exam.name === (localStorage.getItem('examName') || localStorage.getItem('targetExamName'))
        };
        return obj;
      }))
    }
  }

  getHeaders() {
    if (JSON.parse(localStorage.getItem('userInfo'))?.userDto.subTenant != null) {
      return {
        tenantId: JSON.parse(localStorage.getItem('userInfo'))?.userDto.tenantId.toString(),
        subTenantId: JSON.parse(localStorage.getItem('userInfo'))?.userDto.subTenant.toString(),
        authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userInfo'))?.accessToken.toString(),
        'x-tenant' : (JSON.parse(localStorage.getItem('userInfo'))?.tenantName) ? JSON.parse(localStorage.getItem('userInfo'))?.tenantName : 'infinitylearn',
      };
    } else {
      return {
        tenantId: JSON.parse(localStorage.getItem('userInfo'))?.userDto.tenantId.toString(),
        authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userInfo'))?.accessToken.toString(),
        'x-tenant' : (JSON.parse(localStorage.getItem('userInfo'))?.tenantName) ? JSON.parse(localStorage.getItem('userInfo'))?.tenantName : 'infinitylearn',
      };
    }
  }

  getReq(url: any) {
    return this.getWithHeaders(url, this.getHeaders());
  }

  postReq(url: any, payload: any) {
    return this.post(url, payload, this.getHeaders());
  }

  ////  SelfLearn V2.1

  putReq(url: any, payload: any) {
    return this.put(url, payload, this.getHeaders());
  }

  getSubjectName(){
    return localStorage.getItem('selfLearnSelectedSubjectName');
  }

  getSubtenantId() {
    return JSON.parse(localStorage.getItem('userInfo'))?.userDto.subTenant;
  }

  getCmsExamID() {
    let cmsDetails = JSON.parse(localStorage.getItem('cmsInfo'))?.cmsExamId;
    return cmsDetails;
  }
  getCmsExamName(){
    let cmsDetails = JSON.parse(localStorage.getItem('cmsInfo'))?.cmsExamName;
    return cmsDetails;
  }
  getCmsGradeName(){
    let cmsDetails = JSON.parse(localStorage.getItem('cmsInfo'))?.cmsGradeName;
    return cmsDetails;
  }

  getChapterId() {
    return localStorage.getItem("chapterId");
  }

  getChapterName() {
    return localStorage.getItem("chapterName");
  }

  getSubjectId() {
    return localStorage.getItem("selfLearnSelectedSubject");

  }

  getTopicId() {
    return localStorage.getItem("selfLearnSelectedTopicId");
  }

  getTopicName() {
    return localStorage.getItem("selfLearnSelectedTopicName");
  }

  getVideoId() {
    return localStorage.getItem("selfLearnSelectedVideoId");
  }

  getPlayListId() {
    return localStorage.getItem('selfLearnSelectedPlayList');
  }

  getPracticeLevel() {
    return localStorage.getItem('currentLevel');
  }

  getSubtopicCount() {
    return localStorage.getItem('subtopicCount');
  }

  removlearnTabExpandRowIndex() {
    localStorage.removeItem('learnTabExpandIndex');
  }

  generateRandomNumber(min = 500, max = 1000) {
    const difference = max - min;
    let randomNumber = Math.random();
    randomNumber = Math.floor( randomNumber * difference);
    randomNumber = randomNumber + min;
    return randomNumber;
  }

  getVideosByPlayListId(params: any) {
    let url = this.cmsURl + 'video_playlist/get/videos/' + params.examId + '/' + params.subTenantId + '/' + params.playlistTypeId;
    let header = {
      'authorization': 'Bearer ' + localStorage.getItem('token'),
      userId: this.getUserInfo()?.userId.toString()
    };
    return this.getWithHeaders(url, header);
  }

  getVideoDetailsForPlatListTypeId(playlistTypeId: any) {
    let url = this.apiUrlV2 + `/selflearn/getVideoDetailsForPlayListTypeId?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&playlistTypeId=${playlistTypeId}`;
    let header = {
      'authorization': 'Bearer '+ localStorage.getItem('token').toString(),
      userId: this.getUserInfo()?.userId.toString(),
      tenantId: JSON.parse(localStorage.getItem('userInfo'))?.userDto.tenantId.toString(),
      subTenantId: this.getSubtenantId().toString(),
    };
    return this.getWithHeadersAndParams(url, header, {})
  }

  getAllHomeScreenPlaylistVideos(playListIds: any) {
    return new Promise((resolve, reject) => {
      if (this.selfLearnHomepagePlaylsit.listEnabled) {
        resolve(this.selfLearnHomepagePlaylsit)
      } else {
        this.selfLearnHomepagePlaylsit.playlist = [];
        const subTenantId = JSON.parse(localStorage.getItem('userInfo'))?.userDto.subTenant;
        // const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
        // const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
        // let cmsDetails = this.filterCMSData();
        // let cmsExamIds = cmsDetails.map((e:any) => String(e.CMS_Exam_id));
        let cmsExamIds = this.getCmsExamID();
        const trendingVideosParams = {
          examId: cmsExamIds,
          subTenantId: subTenantId,
          playlistTypeId: playListIds[0],
        }
        const recommendedVideosParams = {
          examId: cmsExamIds,
          subTenantId: subTenantId,
          playlistTypeId: playListIds[1],
        }
        const shortsVideosParams = {
          examId: cmsExamIds,
          subTenantId: subTenantId,
          playlistTypeId: playListIds[2],
        }
        const PuzzleVideosParams = {
          examId: cmsExamIds,
          subTenantId: subTenantId,
          playlistTypeId: playListIds[3],
        }
        forkJoin([this.getVideosByPlayListId(trendingVideosParams), this.getVideosByPlayListId(recommendedVideosParams), this.getVideosByPlayListId(shortsVideosParams), this.getVideosByPlayListId(PuzzleVideosParams)]).subscribe((data: any) => {
          this.selfLearnHomepagePlaylsit.trendingVideosPlaylist = this.getVideosFromPlaylist(data?.[0].data);//this.returnVideosMouldList(data?.[0].data);
          this.selfLearnHomepagePlaylsit.recommendedVideosPlayList = this.getVideosFromPlaylist(data?.[1].data); //this.returnVideosMouldList(data?.[1].data);
          this.selfLearnHomepagePlaylsit.shortsVideosPlayList = this.getVideosFromPlaylist(data?.[2].data); //this.returnVideosMouldList(data?.[2]);
          this.selfLearnHomepagePlaylsit.puzzleVideosPlayList = this.getVideosFromPlaylist(data?.[3].data); //this.returnVideosMouldList(data?.[3]);
          resolve(this.selfLearnHomepagePlaylsit)
        },
          (err) => {
            resolve(this.selfLearnHomepagePlaylsit)
            // reject(err)
          })
      }
    })
  }

  returnVideosMouldList(list: any) {
    return {
      id: list?.data?.playlistId,
      playlistTypeId: list?.data?.playlistTypeId,
      name: list?.data?.playListTitle,
      videos: list?.data?.videos?.map((e: any) => {
        e.durationSecs = e.duration;
        e.duration = this.secondsToTime(e.duration);
        return e
      })
    }
  }

  getVideosFromPlaylist(playlistarr: any) {
    let videosList: any = [];
    playlistarr.forEach((playList: any) => {
      playList.videos.forEach((element: any) => {
        videosList.push(element);
      });
    });
    return videosList;
  }

  getWidgetOrders() {
    const url = this.apiUrlV2 + `/selflearn/widgetorders`;
    return this.getReq(url);
  }

  getChaptersForExamAndSubject(subjectId: any,bookId:any) {
    // const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
    // const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
    // let cmsDetails = this.filterCMSData();
    let cmsExamIds = this.getCmsExamID();
    //let cmsExamIds = cmsDetails.map((e:any) => String(e.CMS_Exam_id));
    const subTenantId = JSON.parse(localStorage.getItem('userInfo'))?.userDto.subTenant;
    let url = this.cmsURl + `examtoc/getChaptersForExamSubjectSubtenant?examId=${cmsExamIds}&subjectId=${subjectId}&subtenantId=${subTenantId}&bookId=${bookId}&videoTypeIds=${this.getConfigureVideoTypes()}`;
    let headers = {
      'authorization': 'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId,
    };
    return this.getWithHeaders<any>(url, headers);
  }

  getTopicsAndVideosForExamChapterSubtenant(chapterId: any) {
    // let cmsDetails = this.filterCMSData();
    // let cmsExamIds = cmsDetails.map((e:any) => String(e.CMS_Exam_id));
    let cmsExamIds = this.getCmsExamID();
    const subTenantId = JSON.parse(localStorage.getItem('userInfo'))?.userDto.subTenant;
    let url = this.cmsURl + `examtoc/getTopicsAndVideosForExamChapterSubtenant?chapterId=${chapterId}&examId=${cmsExamIds}&subtenantId=${subTenantId}&videoTypeIds=${this.getConfigureVideoTypes()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId,
    };
    return this.getWithHeaders<any>(url, headers);
  }

  getTopicAndVideosProgress(subjectId: any, chapterId: any) {
    // let cmsDetails = this.filterCMSData();
    // let cmsExamIds = cmsDetails.map((e:any) => String(e.CMS_Exam_id));
    let cmsExamIds = this.getCmsExamID();
    const url = this.apiUrlV2 + `/selflearn/getTopicAndVideosProgress?examId=${cmsExamIds}&gradeId=${this.getGradeId()}&subjectId=${subjectId}&chapterId=${chapterId}&videoTypeIds=${this.getConfigureVideoTypes()}`;
    return this.getReq(url);
  }

  getVideoProgressByTopic() {
    const url = this.apiUrlV2 + `/selflearn/getVideoProgressByTopic?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&topicId=${this.getTopicId()}`;
    return this.getReq(url);
  }

  getChapterProgress(subjectId: any,bookId:any) {
    // const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
    // const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
    //let cmsDetails = this.filterCMSData();
    let cmsExamIds = this.getCmsExamID();
    const url = this.apiUrlV2 + `/selflearn/getChaptersWithProgressAndLockStatus?examId=${cmsExamIds}&gradeId=${this.getGradeId()}&subjectId=${subjectId}&bookId=${bookId}&videoTypeIds=${this.getConfigureVideoTypes()}`;
    return this.getReq(url);
  }

  storeVideoProgress(payload: any) {
    const url = this.apiUrlV2 + `/selflearn/storeVideoProgress`;
    return this.putReq(url, payload);
  }

  getTopicsByChapterExamSubtenant() {
    let url = this.cmsURl + `examtoc/chapter/Topics/getTopicsByChapterExamSubtenant?chapterId=${this.getChapterId()}&examId=${this.getCmsExamID()}&subtenantId=${this.getSubtenantId()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId,
    };
    return this.getWithHeaders<any>(url, headers);
  }

  getPracticeProgress() {
    const url = this.apiUrlV2 + `/practice/getPracticeProgress?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}`;
    return this.getReq(url);
  }

  //Get Subject Exam wise
  getSubjectsForExam(userId: any, examId: any) {
    let url = this.cmsURl + `examtoc/v2/getSubjectsForExam/${examId}?status=${"active"}&subtenantIds=${this.getSubtenantId()}`;
    let headers = {
      'authorization': 'Bearer ' + localStorage.getItem('token'),
      'userId': userId + ""
    };
    return this.getWithHeaders<any>(url, headers);
  }

  submitAndGetPracticeQuestionsV2(payload: any): Observable<any> {
    const url = this.apiUrlV2 + "/practice/submitAndGetPracticeQuestions?version=v2";
    return this.postReq(url, payload);
  }

  updateTopicSummaryQuestion(payload: any): Observable<any> {
    const url = this.apiUrlV2 + "/selflearn/updateTopicSummaryQuestion";
    return this.putReq(url, payload);
  }

  publishedVideoAndFlashcardCount() {
    let url = this.cmsURl + `examtoc/chapter/Topics/publishedVideoAndFlashcardCount?chapterId=${this.getChapterId()}&examId=${this.getCmsExamID()}&subtenantId=${this.getSubtenantId()}`;
    let headers = {
      'authorization':'Bearer '+ localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }

  getTopicSummaryProgress() {
    const url = this.apiUrlV2 + `/selflearn/getTopicSummaryProgress?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}`;
    return this.getReq(url);
  }

  getFlashcardsAndQuestions() {
    let url = this.cmsURl + `flashcard/flashcardsAndQuestions/${this.getTopicId()}/${this.getSubtenantId()}/1`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }

  updateTopicSummaryProgress(payload: any) {
    const url = this.apiUrlV2 + `/selflearn/updateTopicSummaryProgress`;
    return this.putReq(url, payload);
  }

  getTopicSummaryAndQuestions() {
    const url = this.apiUrlV2 + `/selflearn/getTopicSummaryAndQuestions?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&topicId=${this.getTopicId()}`;
    return this.getReq(url);
  }

  getStoriesForExamNodeIds(stotyType:any) {
    //const arr = [this.getCmsExamID()];
    let url = this.cmsURl + `story/getStoriesForExamNodeIds?examIds=${this.getCmsExamID()}&examNodeIds=${this.getChapterId()}&status=Published&storyType=${stotyType}&subtenantIds=${this.getSubtenantId()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }

  getPracticeAnalysis() {
    const url = this.apiUrlV2 + `/practice/getPracticeAnalysis?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&topicId=${this.getTopicId()}`;
    return this.getReq(url);
  }

  getResumeLearningForHomeScreen() {
    const url = this.apiUrlV2 + `/selflearn/getResumeLearningForHomeScreen?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}`;
    return this.getReq(url);
  }

  getReviseQuestions(payload){
    const url = this.apiQb + "questions/ids";
    return this.postReq(url, payload);
  }

  redeemAndUnlockChapter(payload: any): Observable<any> {
    const url = this.apiUrlV2 + `/selflearn/redeemAndUnlockChapterV2`;
    return this.putReq(url, payload);
  }

  checkSubscriptions(payload){
    return this.postReq(this.omsurl+'check-subscriptions', payload);
  }

  getCoinsDetails(): Observable<any> {
    const url = this.uafApi + `coins/getCoinsSummaryByUserId?userId=${this.getUserInfo()?.userId}`;
    return this.get(url);
  }

  saveRedeemSummary(payload:any){
    const url = `${this.myActivityApi}api/redeem/saveRedeemSummary`;
    return this.postReq(url, payload);
  }




  ////  SelfLEarn V1

  getSubjectsBasedOnExamtype(examId: any, userId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/v2/getUserSubjectsPerExam?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}`;
    return this.getReq(url);
  }

  getChaptersBasedOnSubjectAndExamtype(examId: any, userId: any, subjectId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/getUserChaptersForExamAndSubject?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}`;
    return this.getReq(url);
  }

  // updateChapterUnlockStatus(payload: any): Observable<any> {
  //   const url = this.apiUrl + `/selflearn/updateChapterUnlockStatus`;
  //   return this.postReq(url, payload);
  // }

  updateChapterUnlockStatus(payload: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/v2/updateChapterUnlockStatus`;
    return this.postReq(url, payload);
  }

  getTopicsBasedOnChapter(examId: any, userId: any, subjectId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/topicsAndSubtopics?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  getVideosbasedonChapter(examId: any, userId: any, subjectId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/topicsAndVideos?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }
  // getTopicInfobasedOnChapter(chapterId: any): Observable<any> {
  //   const url = this.apiUrl + `/selflearn/usertopic/${chapterId}`;
  //   return this.getReq(url);
  // }

  getFlashCardContentForUser(examId: any, userId: any, subjectId: any, chapterId: any, topicId: any, subTopicId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/getuserflashcardsAndQuestions?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}&topicId=${topicId}&subtopicId=${subTopicId}`;
    return this.getReq(url);
  }

  updateBookmarkForWholeDeck(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard";
    return this.postReq(url, payload);
  }

  saveFeedback(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard/feedback";
    return this.postReq(url, payload);
  }

  raiseAnErrorForIndividualFlashCard(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard/errors";
    return this.postReq(url, payload);
  }

  raiseAnErrorForIndividualQuestion(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard/errors/questions";
    return this.postReq(url, payload);
  }

  rateOverallFlashCard(payload: any) {
    const url = this.apiUrl + "/learn/flashcard/feedback/flashcarddeck";
    return this.postReq(url, payload);
  }

  updateBookmarkForVideo(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/video";
    return this.postReq(url, payload);
  }

  updateBookmarkForVideoForPlaylist(payload: any): Observable<any> {
    const url = this.apiUrl + "/selflearn/v2";
    return this.postReq(url, payload);
  }

  raiseAnErrorForIndividualVideo(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/video/errors";
    return this.postReq(url, payload);
  }

  // practice services

  getAllTopicsForPractice(examId: any, userId: any, subjectId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/getUserTopicsForExamAndSubjectAndChapter?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  submitAndGetPracticeQuestions(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/submitAndGetPracticeQuestions";
    return this.postReq(url, payload);
  }

  rateOverallPractice(payload: any) {
    const url = this.apiUrl + "/practice/feedback";
    return this.postReq(url, payload);
  }

  raiseAnErrorForPracticeQuestion(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/errors";
    return this.postReq(url, payload);
  }

  // practice services

  getBookmarksForUserBasedOnExamAndSubject(examId: any, userId: any, subjectId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/bookmarkeditems?examid=${examId}&gradeId=${this.getGradeId()}&userid=${userId}&subject=${subjectId}`;
    return this.getReq(url);
  }

  raiseAnErrorForIndividualQuestionInbookmarks(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/errors";
    return this.postReq(url, payload);
  }

  submitIndividualQuestionInbookmarks(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/submitAndGetPracticeQuestions";
    return this.postReq(url, payload);
  }

  saveVideoFeedback(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/video/feedback";
    return this.postReq(url, payload);
  }

  getVideoCompletePercentageAnalytics(): Observable<any> {
    const url = this.apiUrl + `/configuration/getVideoCompletePercentageforAnalytics`;
    return this.getReq(url);
  }

  getEventTriggeredStatusForUser(userId: any, eventType: any): Observable<any> {
    const url = this.apiUrl + `/events/getObjectEventStatusforUser/${userId}/${eventType}`;
    return this.getReq(url);
  }

  updateEventTriggeredStatusForUser(payload: any): Observable<any> {
    const url = this.apiUrl + `/events/updateObjectEventStatusforUser`;
    return this.postReq(url, payload);
  }

  // articulation apis

  getUserStoriesBasedOnChapter(examId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/articulation/getUserStoriesAndDetailsforChapter?examId=${examId}&gradeId=${this.getGradeId()}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  getStoryBasedOnId(examId: any, storyId: any): Observable<any> {
    const url = this.apiUrl + `/articulation/getUserStoryDetails?examId=${examId}&gradeId=${this.getGradeId()}&storyId=${storyId}`;
    return this.getReq(url);
  }

  updateStoryStatus(payload: any): Observable<any> {
    const url = this.apiUrl + `/articulation/updateStoryStatus`;
    return this.postReq(url, payload);
  }
  //?recommended videos
  getRecommendedVideos(examId: any, userId: any) {
    // https://selflearnapi.devinfinitylearn.in/api/selflearn/recommendedVideos?examId=1&gradeId=11&userId=290258
    // const url = this.apiUrl + `/articulation/getUserStoriesAndDetailsforChapter?examId=${examId}&gradeId=${this.getGradeId()}&chapterId=${chapterId}`;
    const url = this.apiUrl + `/selflearn/recommendedVideos?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}`;
    return this.getReq(url);
  }
  getVideoPlayList(params: any) {
    params.gradeId = this.getGradeId();
    const url = this.apiUrl + `/selflearn/v2/playlists`;
    return this.getWithHeadersAndParams(url, {}, params)
  }
  get_video(videoid: any, params: any) {
    params.userId = this.getUserInfo()?.userId
    const url = this.apiUrl + `/selflearn/v2/videoSolution/` + videoid;
    return this.getWithHeadersAndParams(url, {}, params)
  }
  getVideoCms(videoid: any) {
    let url = this.cmsURl + 'videos/get_video/' + videoid
    let header = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      userId: this.getUserInfo()?.userId
    }
    return this.getWithHeadersAndParams(url, header, {})
  }
  updateWatchedVideoSolution(payload: any) {
    const url = this.apiUrl + "/selflearn/v2/videoSolution/";
    return this.postReq(url, payload);
  }
  getHomeScreenPlaylist(examId?: any, userId?: any) {
    var mouldList = (list: any) => {
      return {
        id: list?.playlistId,
        playlistTypeId: list?.playlistTypeId,
        name: list?.playListTitle,
        videos: list?.videos?.map((e: any) => {
          e.durationSecs = e.duration;
          e.duration = this.secondsToTime(e.duration);
          return e
        })
      }
    }
    return new Promise((resolve, reject) => {
      if (this.selfLearnHomepagePlaylsit.listEnabled) {
        resolve(this.selfLearnHomepagePlaylsit)
      } else {
        this.selfLearnHomepagePlaylsit.playlist = [];
        if (!examId) {
          const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
          examId = details.find((e: any) => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
        }
        userId = this.getUserInfo()?.userId
        let videoPlayListParams = {
          examId: examId,
          playListTypeId: 1,
          userId: this.getUserInfo()?.userId
        }
        let reelPlayListParams = {
          examId: examId,
          playListTypeId: 2,
          userId: this.getUserInfo()?.userId
        }
        // ,this.getVideoPlayList(params), this.getRecommendedVideos(examId, userId)
        forkJoin([this.getVideoPlayList(videoPlayListParams), this.getVideoPlayList(reelPlayListParams)]).subscribe((data: any) => {
          let plalistdata: any = [];
          if (data?.[0]?.playlists?.length) {
            plalistdata = [...plalistdata, ...data?.[0]?.playlists];
          }
          if (data?.[1]?.playlists?.length) {
            plalistdata = [...plalistdata, ...data?.[1]?.playlists];
          }
          plalistdata?.sort((playlist1: any, playlist2: any) => playlist1?.playlistId - playlist2?.playlistId)
            ?.forEach((playlist: any) => {
              let list1 = mouldList(playlist)
              this.selfLearnHomepagePlaylsit.playlist.push(list1)
            });
          resolve(this.selfLearnHomepagePlaylsit)
        },
          (err) => {
            resolve(this.selfLearnHomepagePlaylsit)
            // reject(err)
          })
      }
    })
  }
  secondsToTime(e: any, isWithLabels?: any) {
    if (e) {
      let split_string = e?.split(/(\d+)/);
      let h = Math.floor(split_string?.[1] / 3600),
        m = Math.floor(split_string?.[1] % 3600 / 60),
        s = Math.floor(split_string?.[1] % 60);
      let result = s?.toString()?.padStart(2, '0') + 's';
      if (!!h) {
        result = (isWithLabels && isWithLabels == true) ? (h?.toString()?.padStart(2, '0') + 'h ' + m?.toString()?.padStart(2, '0') + 'm ' + s?.toString()?.padStart(2, '0') + 's') :
          (h?.toString()?.padStart(2, '0') + ':' + m?.toString()?.padStart(2, '0') + ':' + s?.toString()?.padStart(2, '0') + '');
      }
      else if (!!m) {
        result = (isWithLabels && isWithLabels == true) ? (m?.toString()?.padStart(2, '0') + 'm ' + s?.toString()?.padStart(2, '0') + 's') :
          (m?.toString()?.padStart(2, '0') + ':' + s?.toString()?.padStart(2, '0') + '')
      }

      return result;
    }
    else {
      return 0 + 'sec';
    }
  }
  getCmsData(examId: any, gradeId: any) {

    let url = this.apiUrlV2 + '/selflearn/getMapping?examId=' + examId + '&gradeId=' + gradeId;

    let headers = new HttpHeaders().set('security', 'infinitylearn').set('Content-Type', 'application/json');

    return this.getWithHeaders(url, headers);

  }
  getStoriesInfo(storyId:any){
    let url = this.apiUrlV2 + `/selflearn/getStoryByIdV2?storyId=${storyId}`;
    return this.getReq(url);
  }
  getStoryWithCMSAPI(storyId:any){
    let url = this.cmsURl + `story/get/v2/${storyId}/${JSON.parse(localStorage.getItem('userInfo'))?.userDto.tenantId.toString()}`;
    let headers = {
      withCredentials: true,
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }
  getBooksAndAssetCount(subjectId:any){
    let url = this.cmsURl + `examtoc/getBooksAndAssetCount/${this.getCmsExamID()}/${subjectId}/${this.getSubtenantId()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);

  }
  getDocumentsForExamChapterSubtenant(){
    let url = this.cmsURl + `document/getDocumentsForExamChapterSubtenant/${this.getChapterId()}/${this.getSubtenantId()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }
  updateDocumentProgress(docId:any){
    let payload:any = {
      "examId": this.getCmsExamID(),
      "gradeId": this.getGradeId(),
      "subjectId": this.getSubjectId(),
      "chapterId": this.getChapterId(),
      "chapterName": this.getChapterName(),
      "documentId": docId
    }
    const url = this.apiUrlV2 + "/selflearn/userDocumentProgress";
    return this.putReq(url, payload);
  }

  callTrackingAPI2(payload,xpage) {
   const url = this.apiLsqUrl + `/api/tracking/${this.getUserInfo()?.userId}/userTracking`;
   let headers;
   headers = {
     "X-Page": xpage,
     "X-Platform": "web",
     "X-Product": "1",
    }
   return this.getByHeaders<any>(url, payload, headers);
 }

  getTopicScreenConfiguration(){
    let url = this.apiUrlV2 + `/selflearn/getTopicScreenConfiguration`;
    return this.getReq(url);
  }
  getConfigureVideoTypes(){
    let videoTypes:any = JSON.parse(localStorage.getItem('topicScreenConfiguration')).videoTypes;
    return videoTypes;
  }
  //memory-card 
  getTopicsAndMemoryFlashcardsForExamChapterSubtenant(){
    let url = this.cmsURl + `examtoc/getTopicsAndMemoryFlashcardsForExamChapterSubtenant?chapterId=${this.getChapterId()}&examId=${this.getCmsExamID()}&subtenantId=${this.getSubtenantId()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }
  getBookmarkedMemoryCardsByChapter(){
    let url = this.apiUrlV2 + `/selflearn/getBookmarkedMemoryCardsByChapter?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&chapterId=${this.getChapterId()}`;
    return this.getReq(url);
  }
  updateMemoryCardProgress(payLoad:any){
    let url = this.apiUrlV2 + `/selflearn/updateMemoryCardProgress`;
    return this.putReq(url,payLoad);
  }
  //card of the  day
  getBookmarkedMemoryCards(){
    let url = this.apiUrlV2 + `/selflearn/getBookmarkedMemoryCards?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}`;
    return this.getReq(url);
  }
  getFlashcardByFlashcardIds(payload:any){
    let url = this.cmsURl + `flashcard/getFlashcardByFlashcardIds?flashcardIds=${payload.toString()}`;
    let headers = {
      'authorization':'Bearer '+localStorage.getItem('token'),
      'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url, headers);
  }
  updateCardOfDay(payLoad:any){
    let url = this.apiUrlV2 + `/selflearn/updateCardOfDay`;
    return this.putReq(url,payLoad);
  }
  // exercise APIs 
  getExerciseExamDetails(){
    let payload = {
        "studentid": this.getUserInfo()?.userId.toString(),
        "topic_id": this.getTopicId()
    }
    const url = this.examUrl + "rules/getPracticeExam";
    return this.postReq(url, payload);
  }

  createExerciseForTopic(){
    let payload:any = {
      "subjects": [
        {
          "subjectid": this.getSubjectId().toString(),
          "subjectname": this.getSubjectName(),
          "chapters": [
            {
              "chaptercode": this.getChapterId().toString(),
              "chaptername": this.getChapterName().toString(),
              "topics": [
                {
                  "topiccode": this.getTopicId().toString(),
                  "topicname": this.getTopicName().toString(),
                }
              ]
            }
          ]
        }
      ],
      "coursetype": this.getCmsExamName(),
      "exam_type": this.getCmsExamID().toString(),
      "classes": this.getCmsGradeName().toString(),
      "totalquestions": "10",
      "duration": "10",
      "userid": this.getUserInfo()?.userId.toString(),
      "verify": true,
      "phone": "1234567890"
    }
    const url = this.apiQb + "generatequestions/selflearncyot";
    return this.postReq(url, payload);
  }
  getPracticeQuestions(payload:any){
  const url = this.examUrl + "exam/questions";
  return this.postReq(url, payload);
  }
  getResumeVideoForSubject(){
  let url = this.apiUrlV2 + `/selflearn/getResumeVideos?subjectId=${this.getSubjectId()}&examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&limit=1`
  return this.getReq(url);
  }
  saveQuestionResponse(payLoad:any){
    const url = this.examUrl + "exam/userResponseData";
    return this.postReq(url, payLoad);

  }
  getExcerciseExamResponses(payLoad:any){
    const url = this.examUrl + "exam/getUserResponseData";
    return this.postReq(url, payLoad);
  }
  submitExerciseExam(payLoad:any){
    const url = this.examUrl + "exam/submitExam";
    return this.postReq(url, payLoad);
  }
  getVideoProgressForSolutionVideo(videoId:any){
    let url = this.apiUrlV2 + `/selflearn/getVideoDetails?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&videoId=${videoId}`
    return this.getReq(url);
  }

  updateExerciseProgress(payLoad:any){
    let url = this.apiUrlV2 + '/selflearn/updateExerciseProgress';
    return this.putReq(url, payLoad);
  }
  getAllBookMarkedAssets(type:any,selectedSubjects:any,pageNum:any,pageLimit:any){
    
    let url:any;
    if(type.length >0){
       url = this.apiUrlV2 + `/selflearn/getBookmarkedItemsV2?subjectId=${selectedSubjects.length > 0 ? selectedSubjects: []}&examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&type=${type}&offset=${pageNum}&limit=${pageLimit}`;
    }else{
       url = this.apiUrlV2 + `/selflearn/getBookmarkedItemsV2?subjectId=${selectedSubjects.length > 0 ? selectedSubjects: []}&examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&offset=${pageNum}&limit=${pageLimit}`;
    }

    return this.getReq(url);
  }
  getBannerForExams(){
    let url:any = this.apiUrlV2 +`/selflearn/getPyqMapping?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}`;
    return this.getReq(url);
  }
  getPreviousYearQuestionsForChapter(payLoad:any){
    let url:any = this.apiQb +'questions/getAllQuestions';
    return this.postReq(url,payLoad);
  }
  getPyqAttemptedQuestions(targetExamId:any){
    let url:any = this.apiUrlV2 +`/selflearn/getAttemptedQuestions?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&targetExamId=${targetExamId}`;
    return this.getReq(url);
  }
  getPreviousYearQuestionsCountForChapter(payLoad:any){
    let url:any = this.apiQb +'questions/getAllQuestionsCount';
    return this.postReq(url,payLoad);
  }
  submitPyqResponse(payload:any){
   let url:any =  this.apiUrlV2 +`/selflearn/previousYearQuestions`;
   return this.putReq(url,payload);
  }
  getAssetTypes(){
    let url = this.apiUrlV2 + '/selflearn/getAssetTypes';
    return this.getReq(url);
  }
  getAssetReportOptions(assetId:any){
    let url = this.apiUrlV2 + `/selflearn/getAssetReportOptions/${assetId}`;
    return this.getReq(url);
  }
  postAssetFeedBackReport(payload:any) {
    let url = this.apiUrlV2 + `/selflearn/postAssetFeedBackReport`;
    return this.putReq(url,payload)
  }
  gethistoryAssets(type:any,selectedSubjects:any,pageNum:any,pageLimit:any){  
    let url:any;  
       url = this.apiUrlV2 + `/selflearn/getHistoryV2?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&pageNo=${pageNum}&limit=${pageLimit}&days=30`;
    return this.getReq(url);
  }
  getVideoLikeCount(videoId:any){
    let url = this.apiUrlV2 + `/selflearn/getVideoLikesCount/${videoId}?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}`;
    return this.getReq(url);
  }
  getLikeandDislikeStatusForQuestions(questionIds:any){
    let url = this.apiUrlV2 + `/selflearn/getLikeDetailsByQueId?questionIds=${questionIds}&examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}`;
    return this.getReq(url);
  }
  updateStoryProgress(payLoad:any){
    let url = this.apiUrlV2 +`/selflearn/updateStoryProgress`
    return this.putReq(url,payLoad);
  }
}
